export const DEFAULT_CAROUSEL_SETTINGS = {
  margin: 10,
  nav: true,
  stagePadding: 45,
  lazyLoad: true,
  startPosition: 0,
  responsive: {
    0: {
      items: 1,
      slideBy: 1,
    },
    525: {
      items: 2,
      slideBy: 2,
    },
    992: {
      items: 3,
      slideBy: 3,
    },
    1200: {
      items: 4,
      slideBy: 4,
    },
  },
};



// WEBPACK FOOTER //
// ./ts/app/shared/types/CarouselSettings.ts